<div class="alert-success" *ngIf="showSuccessMsg">
    <img style="margin-right: 1em;" src="../assets/images/checkCircle.svg" alt="successMsg">
    <span>{{successMssg}}</span>
</div>
<div class="alert-failure d-flex flex-column" *ngIf="showErrorMsg">
    <div *ngIf="showNoSupplierErrMsg">
        <img style="margin-right: 1em;" src="../assets/images/errCircle.png" alt="failureMsg">
        <span>{{pageErrorMsg}}</span>
    </div>
    <div *ngIf="showNoLinkErrorMsg">
        <img style="margin-right: 1em;" src="../assets/images/errCircle.png" alt="failureMsg">
        <span>{{linkClickErrorMsg}}</span>
    </div>
    <div *ngIf="showUnionTypeErrMsg">
        <img style="margin-right: 1em;" src="../assets/images/errCircle.png" alt="failureMsg">
        <span>{{unionTypeErrorMsg}}</span>
    </div>
    <div *ngIf="showEvaluationErrMsg">
        <img style="margin-right: 1em;" src="../assets/images/errCircle.png" alt="failureMsg">
        <span>{{evaluationErrorMsg}}</span>
    </div>
    <div *ngIf="showOverallStatusCommentErrMsg">
        <img style="margin-right: 1em;" src="../assets/images/errCircle.png" alt="failureMsg">
        <span>{{overallStatusCommentErrorMsg}}</span>
    </div>
    <div *ngIf="showContingencyPlanErrMsg">
        <img style="margin-right: 1em;" src="../assets/images/errCircle.png" alt="failureMsg">
        <span>{{contingencyPlanErrorMsg}}</span>
    </div>
    <div *ngIf="showMonthlyConfErrMsg">
        <img style="margin-right: 1em;" src="../assets/images/errCircle.png" alt="failureMsg">
        <span>{{monthlyConfErrorMsg}}</span>
    </div> 
</div>
<div *ngIf="displayScreen">
    <div>
        <div class="topBox d-flex justify-content-start">
            <div class="ms-4 ps-1" style="color:#FBFBFC;">
                <b>{{mainTitle}}</b>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="col-md-12 ms-3 mb-3 me-3 mt-1">
            <div class="row">
                <div class="d-flex justify-content-between mt-2">
                    <div>
                        <a class="homePageLinks cursorptr" id="supplierunioncontingency" (click)="onLinkClick()">Supplier Union Contingency Plan Form</a>
                    </div>
                    <div class="d-flex flex-row" [ngClass]="{'disableBtn': disableExportMain}">
                        <label for="export" class="label-tmna mt-2">Export Grid To: </label>
                        <select class="dropdown-tmna ms-2" style="width: fit-content;" (change)="exportType($event.target.value)">
                            <option class="displayTextcss" value="xlsx">Excel.xlsx</option>
                            <option class="displayTextcss" value="xls">Excel.xls</option>
                            <option class="displayTextcss" value="csv">CSV file</option>
                        </select>
                        <button class="closeButton ms-2" style="width: fit-content;" (click)="exportGridData()">
                            <img src="\assets\images\report.png" alt="Export Supplier List" height="16" width="16">
                            EXPORT
                        </button>
                        <button class="closeButton ms-2 me-4" style="width: fit-content" (click)="exportManagerReportdata()">
                            <img src="\assets\images\report.png" alt="Export Supplier List" height="16" width="16">
                            MANAGER REPORT
                        </button>
                    </div>
                </div>
            </div>
            <div class="row mt-2" style="margin-bottom: 50px">
                <div class="flex-row mt-2" id="dataForMainSupplierDetails">
                    <ag-grid-angular class="ag-theme-balham inl-grid-size me-4" [rowData]="rowdataForMainSupplierDetails"  [columnDefs]="columnDefMainSupplierDetails"
                        (gridReady)="onGridReady($event)" headerHeight="74" [defaultColDef]="defaultColDef" [icons]="icons" [tabToNextCell]="tabToNextCell"
                        [domLayout]="domLayout" [groupDisplayType]="groupDisplayType" [floatingFiltersHeight]="50" [context]="gridContext"
                        [rowGroupPanelShow]="'always'" [suppressDragLeaveHidesColumns]="true" [animateRows]="true" [excelStyles]="excelStyles"
                        [tooltipShowDelay]="tooltipShowDelay" [enableCellTextSelection] = "true">
                    </ag-grid-angular>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="displayUnauthorized">
    <div class=" container unauthorized">
        <p></p>
        <p style="color: red;">You do not have a role assigned to access this Application.</p>
        <p>Please raise a request using 
        <a style="color: #2688Da; text-decoration:underline" href="https://ep.idm.toyota.com/identityiq/home.jsf" >SailPoint</a>.
        Refer to the <span style="color: #2688Da; text-decoration:underline; cursor:pointer">User Guide</span>
        for more details.
        </p>
        <p style="color: #2688Da; text-decoration:underline; cursor: pointer;" 
            (click)="cancelNullGuidAssume()" 
            (keydown)="cancelNullGuidAssume()" 
            *ngIf="cancelAssumedUser" >Cancel Assume</p>
    </div>
</div>